var RequestingGrid;
var RequestingGridLegacyName;
var RequestingGridIndex;
var ShiftKeyDown = false;
var CtrlKeyDown = false;

$(function () {
    var themeSelected;

    if (localStorage) {
        if (localStorage.getItem("Theme") !== null) {

            themeSelected = localStorage.getItem("Theme");

            // Handle old local store variable saved as boolean
            if (themeSelected === "false") {
                themeSelected = "Light";
            }
            else if (themeSelected === "true") {
                themeSelected = "Dark";
            }

            if (themeSelected !== 'Light') {
                ToggleTheme(themeSelected);
            }

        }

        var highContrast = localStorage.getItem("HighContrast") === "true";

        ToggleHighContrastTheme(highContrast);
        $("#ContrastCheckbox").dxCheckBox({ value: highContrast });

        var compactMode = localStorage.getItem("CompactMode") === "true";

        ToggleCompactTheme(compactMode);
        $("#CompactCheckbox").dxCheckBox({ value: compactMode });

        var autoRefresh = localStorage.getItem("AutoRefreshOff") === "true";

        ToggleAutoRefresh(autoRefresh);
        $("#AutoRefreshCheckbox").dxCheckBox({ value: !autoRefresh });
    }

    $(".Truckcom_Navbar_Dropdown, .Truckcom_Navbar_Notifications li").on("mouseenter", function () {
        $(this).addClass("Truckcom_Navbar_Dropdown_Active");
    });

    $(".Truckcom_Navbar_Dropdown, .Truckcom_Navbar_Notifications li").on("mouseleave", function () {
        var item = $(this);
        setTimeout(function () {
            item.removeClass("Truckcom_Navbar_Dropdown_Active");
        }, 500);
    });

    // A right-opening side flyout (the Pallet-Track groups) flips to the left when it would run
    // off the screen - that tab ends a long navbar, so on a narrow monitor there is no room.
    // Measured unflipped on every entry, as the window may have been resized since. Static on
    // phones (Bootstrap stacks the menus), where it is left alone.
    $(".Truckcom_Dropdown_Menu_Side").on("mouseenter", function () {
        var flyout = $(this).children(".Truckcom_Dropdown_Menu_Side_Content_Right");

        flyout.removeClass("Truckcom_Dropdown_Menu_Side_Flip");

        if (flyout.length === 0 || flyout.css("position") !== "absolute") {
            return;
        }

        if (flyout[0].getBoundingClientRect().right > document.documentElement.clientWidth) {
            flyout.addClass("Truckcom_Dropdown_Menu_Side_Flip");
        }
    });
});

function ToggleTheme(theme) {
    var themeLink = $('#theme_css');

    // Use the cache-busted urls the layout emits. A bare path would be served from
    // browser cache, so theme updates would never reach the user.
    var darkThemePath = themeLink.attr('data-dark-href') || '/Content/CSS/dx-Truckcom-Theme-Dark.css';
    var lightThemePath = themeLink.attr('data-light-href') || '/Content/CSS/dx-Truckcom-Theme-Light.css';

    var darkThemeClass = 'Truckcom-Dark';
    var lightThemeClass = 'Truckcom-Light';

    if (theme === 'Dark') {
        $('#theme_css').attr('href', darkThemePath);
        $('body').removeClass(lightThemeClass);
        $('body').addClass(darkThemeClass);
    }
    else if (theme === 'Light') {
        $('#theme_css').attr('href', lightThemePath);
        $('body').removeClass(darkThemeClass);
        $('body').addClass(lightThemeClass);
    }

    localStorage.setItem("Theme", theme);
}

function ToggleHighContrastTheme(highContrastOn) {
    var highContrastThemeClass = 'Truckcom-HiContrast';

    if (highContrastOn) {
        $('body').addClass(highContrastThemeClass);
    } else {
        $('body').removeClass(highContrastThemeClass);
    }

    localStorage.setItem("HighContrast", highContrastOn);
}

function ToggleCompactTheme(compactModeOn) {
    var compactThemeClass = 'Truckcom-Compact';

    if (compactModeOn) {
        $('body').addClass(compactThemeClass);
    } else {
        $('body').removeClass(compactThemeClass);
    }

    localStorage.setItem("CompactMode", compactModeOn);
}

function ToggleAutoRefresh(autoRefresh) {
    localStorage.setItem("AutoRefreshOff", autoRefresh);
}

/* Popup Functions */
function CloseEditFormPopup() {
    ClosePopup("EditFormPopup");
}

function CloseViewPopup() {
    // ViewPopup is created by SetupPopup, whose onHidden handler disposes the
    // widget AND recreates a fresh host div. Disposing directly skips onHidden,
    // leaving a dirty host that corrupts the next open (stale content flash,
    // wrong columns, stuck loading) - hide() runs the full teardown.
    var element = document.getElementById("ViewPopup");
    var popup = element ? DevExpress.ui.dxPopup.getInstance(element) : null;
    if (popup) {
        popup.hide();
    }
}

function CloseBasePopup() {
    ClosePopup("BasePopup");
}

function CloseAdvancedSearchPopup() {
    FormTitle = "";
    RequestingGrid = "JobsGrid";
    ActiveDataGrid = "JobsGrid";
    ClosePopup("AdvancedSearchPopup");
}

function CloseEmailPopup() {
    ClosePopup("EmailPopup");
}

function CloseAddNewPopup() {
    ClosePopup("AddNewPopup");
}

function CloseJobDetailsPopup() {
    ClosePopup("JobDetailsPopup");
}

function CloseDrillDownPopup() {
    ClosePopup("DrilldownPopup");
}

function CloseManageViewsPopup() {
    ClosePopup("ManageViewsPopup");
    var grid = $("#" + ManageViews_PreviousGridId).dxDataGrid("instance");
    if (grid) {
        grid.refresh();
    }
}

// 26.1 renders overlay content in a body-level wrapper, so "#host .dx-popup-content"
// descendant queries match nothing - resolve the content via the widget instance.
function PopoverContent(hostId) {
    var el = document.getElementById(hostId);
    var w = el && (DevExpress.ui.dxPopover.getInstance(el) || DevExpress.ui.dxPopup.getInstance(el));
    return w ? $(w.content()) : $();
}

// Hides a popover's OK/Cancel for a view that brings its own buttons. 26.1 keeps the toolbar when
// the content changes (19.1 rebuilt it), so it comes back then or the next selector has no OK.
function HidePopoverToolbarUntilContentChanges(popover) {
    var toolbar = $(popover.content()).siblings(".dx-popup-bottom").hide();

    popover.on("optionChanged", function showToolbar(e) {
        if (e.name !== "contentTemplate") {
            return;
        }

        popover.off("optionChanged", showToolbar);
        toolbar.show();
    });
}

// 26.1 lays popup content out asynchronously in its body-level wrapper - wait
// until an element inside it has real dimensions before measuring it or creating
// size-dependent widgets (the CKEditor email editor collapses its toolbar when
// initialised at zero width).
function WhenPopupContentReady(hostId, innerSelector, callback, attempt, lastHeight) {
    var el = PopoverContent(hostId).find(innerSelector);

    // Ready = the element has a size AND that size matched on two consecutive
    // polls. The popup is often resized just after its content loads (e.g.
    // PopupLoaded's ResizePopup shrinking the 26.1 default to a PopupSize), so
    // measuring on first sight can capture the pre-resize height and leave
    // content overflowing the final popup.
    if (el.length && el.width() > 0 && el.height() > 0 && el.height() === lastHeight) {
        callback(el);
        return;
    }

    if ((attempt || 0) > 60) {
        callback(el);
        return;
    }

    setTimeout(function () {
        WhenPopupContentReady(hostId, innerSelector, callback, (attempt || 0) + 1, el.length ? el.height() : undefined);
    }, 50);
}

function ClosePopup(popupId) {
    // 26.1 renders popup content in a body-level overlay wrapper, so the host div
    // has no children while open - detect an initialised popup via its instance.
    var element = document.getElementById(popupId);
    var popup = element ? DevExpress.ui.dxPopup.getInstance(element) : null;
    if (popup) {
        popup.dispose();
    }
}

function CloseAndRemovePopup(popupId) {
    var element = document.getElementById(popupId);
    var popup = element ? DevExpress.ui.dxPopup.getInstance(element) : null;
    if (popup) {
        popup.dispose();
        $("#" + popupId).remove();
    }
}

// A tabbed popup keeps the size of its largest tab, so it doesn't change size as tabs are clicked. Call it once the
// popup is sized; tabs must be rendered up front (deferRendering: false). Width goes first, so heights are measured
// at the width the popup keeps.
function TabPanel_KeepLargestTabSize(tabPanelElement) {
    var container = $(tabPanelElement).find(".dx-multiview-item-container").first();
    TabPanel_KeepLargestTab(container, "width", "max-content");
    TabPanel_KeepLargestTab(container, "height", "auto");
}

// DevExtreme sizes a hidden tab to the shown one, so each is measured with that lifted for a moment - hidden tabs sit
// off-screen, so nothing visibly moves. The kept size alone never pushes the buttons past the window (an auto-sized
// popup) or out of the popup (a fixed-size one); a tab that is itself too big still overflows, as it always has.
function TabPanel_KeepLargestTab(container, dimension, liftedTo) {
    var isWidth = dimension === "width";
    var largest = 0;

    container.children(".dx-multiview-item").each(function () {
        var parts = [this].concat($(this).children(".dx-multiview-item-content").get());
        var saved = [];
        for (var i = 0; i < parts.length; i++) {
            saved.push(parts[i].style[dimension]);
            parts[i].style[dimension] = liftedTo;
        }
        largest = Math.max(largest, isWidth ? $(this).outerWidth() : $(this).outerHeight());
        for (i = 0; i < parts.length; i++) {
            parts[i].style[dimension] = saved[i];
        }
    });
    if (largest <= 0) return;

    var minProperty = isWidth ? "min-width" : "min-height";
    container.css(minProperty, largest + "px");

    // A fixed-size popup clips at the tab panel's own wrapper (overflow: hidden), so that is checked as well as the popup.
    // Width is trimmed to exactly the visible width, as DevExtreme fits a too-wide tab itself; height keeps a margin.
    var overlay = container.closest(".dx-overlay-content");
    var popupContent = container.closest(".dx-popup-content")[0];
    var wrapper = container.parent()[0];
    var pastWindow = isWidth ? overlay.outerWidth() - document.documentElement.clientWidth : overlay.outerHeight() - window.innerHeight;
    var margin = isWidth ? 0 : 10;
    var pastPopup = !popupContent ? 0 : isWidth ? popupContent.scrollWidth - popupContent.clientWidth
                                                : popupContent.scrollHeight - popupContent.clientHeight;
    var pastWrapper = isWidth ? wrapper.scrollWidth - wrapper.clientWidth : wrapper.scrollHeight - wrapper.clientHeight;
    var overflow = Math.max(pastWindow > 0 ? pastWindow + margin : 0, pastPopup, pastWrapper);
    if (overflow > 0) {
        container.css(minProperty, Math.max(0, largest - overflow) + "px");
    }
}

// Hide both shaded loading panels. Call this on any error path that puts a popup on
// screen: the load panels sit above the popup stack and their shading eats clicks, so
// an indicator left visible makes the error popup underneath impossible to dismiss.
// Guarded because not every layout has initialised these panels by the time we fail.
function HideLoadingIndicators() {
    $.each(["LoadIndicator", "SaveIndicator"], function (index, indicatorId) {
        var indicator = $("#" + indicatorId).data("dxLoadPanel");

        if (indicator) {
            indicator.option("visible", false);
        }
    });
}

function PasswordChangeCallback(values, userId, isNewUser) {
    var newPassword = values[0];

    $("#SaveIndicator").dxLoadPanel("instance").option("visible", true);
    
    var PasswordData = {
        Password: newPassword,
        UserId: userId
    };

    $.ajax({
        type: "POST",
        data: JSON.stringify(PasswordData),
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        url: "/api/AFUtils/ChangePassword",
        success: function (data) {
        },
        error: function (data) {
            if (data.status !== 300) {
                if (!isNewUser) {
                    ShowSuccessToast("Password successfully changed");
                }
                $("#PopupContainer").dxPopup("hide");
                $("#SaveIndicator").dxLoadPanel("instance").option("visible", false);
            } else {
                ShowWarningPopup("New password must be different from the current password", "Password not set", true, true);              
                $("#SaveIndicator").dxLoadPanel("instance").option("visible", false);
            }
        }
    });    
}

function OpenChangePasswordPopup(passwordComplexityRequired, userId, isNewUser) {
    var passwordComplexityValidationRules = [];

    if (passwordComplexityRequired) {
        passwordComplexityValidationRules = [{
            type: "pattern",
            pattern: "^(?=.*[A-Z])",
            message: "Password must contain at least 1 uppercase character"
        }, {
            type: "pattern",
            pattern: "^(?=.*[a-z])",
            message: "Password must contain at least 1 lowercase character"
        }, {
            type: "pattern",
            pattern: "[^A-Za-z0-9]",
            message: "Password must contain at least 1 special character"
        }, {
            type: "pattern",
            pattern: "^(?=.*[0-9])",
            message: "Password must contain at least 1 number"
        }, {
            type: "pattern",
            pattern: "^(?=.{8,})",
            message: "Password must be at least 8 characters long"
        }];
    }

    GenericPrompt("Please enter new password", ["Enter Password*~", "Confirm Password#EnterPassword"], PasswordChangeCallback, passwordComplexityValidationRules, userId, isNewUser);
}

function OpenViewPopup(popupUrl, popupTitle) {
    OpenTcvPopup(popupUrl, popupTitle);
}

function OpenBasePopup(popupUrl, popupTitle) {
    OpenTcvPopup(popupUrl, popupTitle);
}

function OpenEditPopup(popupUrl, popupTitle, ignoreIfBlank) {
    OpenTcvPopup(popupUrl, popupTitle, ignoreIfBlank);
}

function OpenTcvPopup(popupUrl, popupTitle, ignoreIfBlank) {
    $.ajax({
        type: "POST",
        url: popupUrl,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (response) {
        },
        failure: function (response) {            
            alert(response.responseText);
        },
        error: function (response) {
            if (!ignoreIfBlank || response.responseText !== '') {
                SetupPopup("", "", "", response.responseText, popupTitle);
            }
        }
    });
}

function GenericPrompt(header, fields, callback, additionalValidationRules, extraCallbackParam, extraCallbackParam2) {
    $("#PopupContainer").dxPopup({
        title: header,
        visible: true,
        width: 400,
        height: 165,
        contentTemplate: function (contentElement) {
            var cleanedFieldNames = [];
            $.each(fields, function (index, field) {
                var textBoxMode = "text";

                if (field.toLowerCase().indexOf("password") > -1) {
                    textBoxMode = "password";
                }
                
                var validationRules = [];

                if (field.indexOf("*") > -1) {
                    // Fields that end with * have a required validator added
                    field = field.replace("*", "");
                    var requiredFieldText = field.substring(0, field.indexOf("*"));
                    validationRules.push({
                        type: "required",
                        message: requiredFieldText + " is required"
                    })
                }

                if (field.indexOf("#") > -1) {
                    // Fields that include # have a comparison validator added - value must match that in the field that is after the # 
                    var matchField = field.substring(field.indexOf("#") + 1);
                    field = field.substring(0, field.indexOf("#"));

                    validationRules.push({
                        type: "compare",
                        comparisonTarget: function () {
                            var compareToTextBox = $("#" + matchField).dxTextBox("instance");
                            if (compareToTextBox) {
                                return compareToTextBox.option("value");
                            }
                        },
                        message: "Values do not match"
                    });
                }

                if (field.indexOf("~") > -1 && additionalValidationRules != undefined) {
                    // Field includes the ~ indicating to include the additional validation rules for this field (i.e password complexity) 
                    field = field.substring(0, field.indexOf("~"));

                    $.each(additionalValidationRules, function (i, additionalValidationRule) {
                        validationRules.push(additionalValidationRule);
                    });
                }

                cleanedFieldNames.push(field);

                contentElement.append($("<div class='dx-field' />")
                    .append($("<div class='dx-field-label'>" + field + "</div>"))
                    .append($("<div class='dx-field-value' />").attr("id", field.replace(/\s+/g, '')).dxTextBox({
                        mode: textBoxMode
                    }).dxValidator({
                        validationRules: validationRules
                    })
                    ));
            });

            contentElement.append($("<div />").attr("id", "ButtonContainer").addClass("Truckcom_Popup_ButtonContainer_NoMarginBottom"));

            $("<div/>").attr("id", "templateOkButton").appendTo("#ButtonContainer").dxButton({
                text: "OK",
                type: "default",
                elementAttr: { class: "Truckcom_Button " },
                onClick: function (e) {
                    if (e.validationGroup.validate().isValid) {
                        var values = [];
                        $.each(cleanedFieldNames, function (i, field) {
                            values[i] = $("#" + field.replace(/\s+/g, '')).dxTextBox('option', 'value');
                        });
                        callback(values, extraCallbackParam, extraCallbackParam2);
                    }
                }
            });

            $("<div/>").attr("id", "templateCancelButton").appendTo("#ButtonContainer").dxButton({
                text: "Cancel",
                elementAttr: { class: "Truckcom_Button " },
                onClick: function (e) {
                    $("#PopupContainer").dxPopup("dispose");
                }
            });
        },
        onShown: function () {
            $("#" + fields[0].replace(/\s+/g, '') + " input").focus();
        }
    });
}

/* Create Controls functions */
function CreateTimeEntryControl(id, value) {
    $("#" + id).addClass("dx-texteditor dx-editor-outlined Truckcom_TimePicker");

    $("#" + id).append("<div class=\"dx-texteditor-container\"><input id=\"" + id + "Input\" class=\"dx-texteditor-input\"/></div>");

    if (value !== "" && value !== undefined) {
        var timeToSet = (value.getHours() < 10 ? '0' : '') + value.getHours() + ":" + (value.getMinutes() < 10 ? '0' : '') + value.getMinutes();
        $("#" + id + "Input").val(timeToSet);
    }
}

function CreateTimePicker(id, value, timePickerFormat, formId) { // Time picker created for edit forms    
    if (timePickerFormat === "1") { //ST Format time picker - only the popover used
        var existingTime = "";
        if (value !== "" && value !== undefined) {
            var timeToSet = Pad(value.getHours(), 2) + ":" + Pad(value.getMinutes(), 2);
            if (timeToSet !== "NaN:NaN") {
                existingTime = timeToSet;
            }
        }

        $("<div>").appendTo($("#" + id)).dxButton({
            text: existingTime,
            elementAttr: { "class": "Truckcom_Form_Picklist_Button" },
            onClick: function (e) {
                PopoverContent("STTimePickerEditor").empty();

                var stTimePicker = CreatePicker("", id, formId);

                $("#STTimePickerEditor").dxPopover({
                    visible: true,
                    target: $("#" + id),
                    closeOnOutsideClick: false,
                    hideOnOutsideClick: false
                });

                PopoverContent("STTimePickerEditor").append(stTimePicker);

                if (value !== "" && value !== undefined) {
                    var hours = Pad(value.getHours(), 2);
                    var minutes = Pad(value.getMinutes(), 2);

                    SetTimeValue(hours, minutes);
                }

                if (!isEdge()) {
                    var cleave = new Cleave("#TimePickerInput", {
                        time: true,
                        timePattern: ['h', 'm']
                    });
                }
                else {
                    EdgeCompatibleTimeEntry($("#TimePickerInput"));
                }

                $("#TimePickerInput").focus();
            }
        });


    } else { // Standard time entry text box 
        CreateTimeEntryControl(id, value);
        if (!isEdge()) {
            var cleave = new Cleave("#" + id + "Input", {
                time: true,
                timePattern: ['h', 'm']
            })
        }
        else {
            EdgeCompatibleTimeEntry($("#" + id + "Input"));
        }
    }
}

function GetTimePickerValue(id, timePickerFormat) {
    if (timePickerFormat === "1") { //ST Format time picker
        var stTimePickerVal = $("#" + id + ".Truckcom_TimeUpdate_TimeBox .Truckcom_Form_Picklist_Button").dxButton("instance").option("text");

        if (stTimePickerVal != "") {
            return stTimePickerVal;
        }
    }
    else {
        if ($("#" + id + " input").val() != "") {
            var enteredValue = CorrectTimeEntryFormat($("#" + id + " input").val());
            return enteredValue;
        }
    }
}

function CorrectTimeEntryFormat(timeEntered) {
    var enteredValue = timeEntered;

    if (timeEntered !== "" && timeEntered.length < 5) { // Time is not in correct format
        enteredValue = "";
        for (var i = 0; i < 5; i++) { // We need a 5 digit time string (00:00)
            if (timeEntered[i] !== undefined) {
                enteredValue += timeEntered[i]; // Add whatever value has been entered
            } else {
                if (i === 2) { // Add the colon separator
                    enteredValue += ":";
                } else { // Any missing digits set to 0
                    enteredValue += "0";
                }
            }
        }
    }

    return enteredValue;
}

function ResizeAutoFormFields(colCount) {
    //Resizes the form fields for the auto edit form - specific class and sizes required for these forms
    if ($(".Truckcom_Form .dx-texteditor-input").length > 0) {
        var textBoxWidth;

        if (isIE()) {
            var popupWidth = $("#EditForm_Container").width();
            var widestLabel = $(".dx-field-item-label").width();
            var padding = 25 * (colCount - 1);
            textBoxWidth = (popupWidth / colCount) - (widestLabel + padding);
        }
        else {
            $(".Truckcom_Form .dx-item-content:not(.dx-collection)").each(function () {
                $(this).width(420);
            });

            // Size the date picker controls
            $(".Truckcom_Form .dx-datebox").each(function () {
                $(this).width("inherit");
            });
        }
    }
}

function ViewCallback(objectIds, methodName, datasetFullyQualifiedName, modelName, popupId, closeFormAfter, successMethod, startdate, enddate, preventLoadingIcon, parentId, parentId2, parentId3) {
    {
        var theModel;

        if (typeof eval(modelName) === "string") {
            theModel = eval(modelName);
        } else {
            theModel = JSON.stringify(eval(modelName));
        }

        if (!preventLoadingIcon) {
            $('#LoadIndicator').dxLoadPanel("instance").option("visible", true);
        }

        var CallbackObject = {
            ObjectIds: objectIds,
            Name: methodName,
            datasetFullyQualifiedName: datasetFullyQualifiedName,
            model: theModel,
            StartDate: startdate,
            EndDate: enddate,
            ParentID: parentId,
            ParentID2: parentId2,
            ParentID3: parentId3
        };

        var ClientDialogObject = {
            ObjectIds: objectIds,
            Name: methodName,
            datasetFullyQualifiedName: datasetFullyQualifiedName,
            StartDate: startdate,
            EndDate: enddate
        };

        ClientDialog.push(ClientDialogObject);

        $.ajax({
            type: 'POST', url: '/Home/CallBack',
            data: JSON.stringify(CallbackObject),
            contentType: 'application/json; charset = utf-8', dataType: 'json',
            success: function (data) {
                var CallbackObject = {
                    IdstoRemove: data.IdsToRemove,
                    Success: "true",
                    time: new Date().toString()
                };
                
                ClientDialog.push(CallbackObject);
                if (JSON.parse(closeFormAfter.toLowerCase())) {
                    if ($('#' + popupId).hasClass("Truckcom_Auto_Popup")) {
                        CloseAndRemovePopup(popupId);
                    } else {
                        ClosePopup(popupId);
                    }
                }
                var myDataGrid = $('#' + RequestingGrid).dxDataGrid('instance');

                if (successMethod !== "") {
                    if (successMethod.indexOf("(") > 0) {
                        eval(successMethod);
                    } else {
                        var theresult = window[successMethod](data);
                        if (theresult && theresult.includes("Popup")) {
                            popupId = theresult;
                        }
                    }
                }

                if (typeof RequestingGrid != "undefined" && typeof window[RequestingGrid + "_SelectorType"] !== "undefined" && data.ObjectType === eval(RequestingGrid + "_SelectorType")) {
                    if (RequestingGrid == "InvoiceableJobs") {
                        RefreshInvoiceableJobsGrid();
                    }
                    else {
                        $.each(data.IdsToRemove, function (index, element) {
                            var rowIndex = myDataGrid.getRowIndexByKey(element);
                            var visibleRows = myDataGrid.getVisibleRows().length;
                            if (visibleRows > myDataGrid.pageSize()) {
                                // If we are showing more than the page size then just hide the row for now.
                                // Skip ids not in the grid (the rejected-save {-1} sentinel): getRowElement(-1) is the LAST row.
                                if (rowIndex >= 0) {
                                    $(myDataGrid.getRowElement(rowIndex)).hide();
                                }
                            }
                            else {
                                // Can delete it via push 
                                eval(RequestingGrid + "_DataStore").push([{ type: "remove", key: element }]);
                            }

                            var GridData = eval(RequestingGrid + "_GridData");
                            var indextoremove = -1;
                            $.each(eval(RequestingGrid + "_GridData"), function (theindex, row) {

                                if (row.DatabaseID == element) {
                                    indextoremove = theindex;
                                }
                            });

                            // Only splice a row we actually found. splice() reads a negative
                            // index as an offset from the END, so the unguarded call deleted the
                            // LAST row of the grid whenever the id was not present - which is
                            // exactly what happens when a save callback rejects and returns an
                            // empty dataset, because the {-1} sentinel then comes back in
                            // IdsToRemove and matches no row.
                            if (indextoremove !== -1) {
                                GridData.splice(indextoremove, 1);
                            }
                        });
                        var LastIndex = 0;

                        $.each(data.DatasetObjects, function (index, element) {
                            var rowIndex = -1;
                            if (myDataGrid != undefined) {
                                rowIndex = myDataGrid.getRowIndexByKey(element.DatabaseID);
                            }

                            if (rowIndex > -1) {
                                var row = myDataGrid.getVisibleRows()[rowIndex];

                                $.each(Object.keys(element), function (index, e) {
                                    $('#' + RequestingGrid).dxDataGrid('instance').getVisibleRows()[rowIndex].data[e] = element[e];
                                });
                                LastIndex = rowIndex + 1;
                                myDataGrid.repaintRows(rowIndex);
                            } else {
                                PushReturnedRowIntoGrid(RequestingGrid, myDataGrid, element, LastIndex);
                            }

                        });

                        if (data.UpdateGroupedJobs && (data.DatasetObjects[0].GroupedJobs !== "" || data.DatasetObjects[0].PairedJobs !== "" || (data.DatasetObjects[0].PlannedJobs !== undefined && data.DatasetObjects[0].PlannedJobs !== ""))) {
                            // Trigger the background update only on this grid for the changed job ids
                            var groupValue = data.DatasetObjects[0].GroupedJobs;

                            if (data.DatasetObjects[0].PairedJobs !== undefined && data.DatasetObjects[0].PairedJobs !== "") {
                                groupValue = data.DatasetObjects[0].PairedJobs;
                            }

                            // ICL plan-pair: refresh partner rows via PlannedJobs CSV.
                            if (data.DatasetObjects[0].PlannedJobs !== undefined && data.DatasetObjects[0].PlannedJobs !== "") {
                                groupValue = data.DatasetObjects[0].PlannedJobs;
                            }

                            BackgroundUpdate(RequestingGrid, groupValue);
                        }

                        if (RequestingGrid == "WeeklyTimeSheetsGrid" && data.DatasetObjects.length > 0) {
                            BackgroundUpdate(RequestingGrid, data.DatasetObjects[0].DatabaseID);
                        }

                        UpdateGridText(RequestingGrid);
                    }
                }
                else if (typeof RequestingGrid != "undefined" && typeof window[RequestingGrid + "_SelectorType"] !== "undefined" && (data.ObjectType === "StcLeg" || data.ObjectType === "StcPalletLeg") && (window[RequestingGrid + "_SelectorType"] == "StcJob" || window[RequestingGrid + "_SelectorType"] == "StcPalletJob")) {
                    // We are in a jobs grid but the object that has been updated is a leg - trigger the job to be updated to update the properties
                    if (data.DatasetObjects[0].Id !== undefined && data.DatasetObjects[0].LegLetter !== undefined) {  
                        var jobId = parseInt(data.DatasetObjects[0].Id.replace(data.DatasetObjects[0].LegLetter, ""));
                        if (!isNaN(jobId)) {
                            BackgroundUpdate(RequestingGrid, jobId);                            
                        }
                    }
                }

                // A callback that changed legs (the different-date confirm, a resource form's OK) may
                // have moved them between resources.
                RefreshProfitCentreRowsAfterLegChange(data.ObjectType);

                // The date confirm after a drop, or a leg form opened from a run's legs grid, may have changed that run's stops
                if ((data.ObjectType === "StcLeg" || data.ObjectType === "StcPalletLeg") && typeof RecalculateRunEtasAfterGridChange === "function") {
                    RecalculateRunEtasAfterGridChange(RequestingGrid);
                }

                if (data.Warning !== "" && data.Warning !== null) {
                    // If a warning popup from a prior request is still on screen
                    // (e.g. the save response showed a container-duplicate warning,
                    // and this CallBack response brings a "New Job Entered" warning),
                    // merge into the existing popup so the first warning isn't hidden
                    // by the second. Falls back to ShowWarning when no popup is open.
                    var existingPopup = $("#WarningPopup").data("dxPopup");
                    var existingContent = $("#WarningPopupContent");
                    var mergedIntoExisting = false;
                    if (existingPopup && existingPopup.option("visible") === true && existingContent.length > 0) {
                        // The Warning view HTML-encodes the message, so `<br>` arrives as `&lt;br&gt;`.
                        // Decode first so the split regex matches and the resulting HTML renders line breaks.
                        var decodedWarning = htmlDecode(data.Warning);
                        // Normalise <br> variants (`<br>`, `<br/>`, `<br />`) before splitting so dedup compares cleanly.
                        var brSplitRegex = /<br\s*\/?>/i;
                        var existingHtml = existingContent.html() || "";
                        var existingLines = existingHtml.split(brSplitRegex).map(function (s) { return s.trim(); });
                        var newLines = decodedWarning.split(brSplitRegex).map(function (s) { return s.trim(); }).filter(function (s) {
                            return s !== "" && existingLines.indexOf(s) === -1;
                        });
                        if (newLines.length > 0) {
                            var appended = newLines.join("<br>");
                            // Use a blank line (two <br>) between warnings from different
                            // requests so they're visually separated in the popup.
                            existingContent.html(existingHtml + "<br><br>" + appended);
                            var hiddenInput = PopoverContent("WarningPopup").find("#hiddenInput");
                            if (hiddenInput.length > 0) {
                                hiddenInput.val(hiddenInput.val() + "\r\n\r\n" + appended.replace(/<br\s*\/?>+/gi, "\r\n"));
                            }
                        }
                        mergedIntoExisting = true;
                    }
                    if (!mergedIntoExisting) {
                        ShowWarning(data.Warning);
                    }
                }

                if (data.View !== null) {
                    if (data.View.substring(0, 4) === "http" || data.View.substring(0, 1) == "/") {
                        window.open(data.View, "_blank");
                    } else {
                        var newPopupId = GetPopupIdFromView(data.View.substring(0, 30));

                        $('#' + newPopupId).dxPopup({
                            contentTemplate: function (contentElement) {
                                contentElement.append(data.View);
                            },
                            showTitle: true,
                            title: 'Information',
                            visible: true,
                            onHidden: function () {
                                $('#' + newPopupId).dxPopup('instance').option('contentTemplate', null);
                                $('#' + newPopupId).dxPopup('instance').dispose();                                
                            },
                            onShown: function () {
                                $('#LoadIndicator').dxLoadPanel('instance').option('visible', false);
                            },
                            onInitialized: function () {
                                $('#' + newPopupId).hide();
                            },
                            onDisposing: function () {
                                var CallbackObject = {
                                    Message: newPopupId + " Closing",
                                    time: new Date().toString()
                                };

                                ClientDialog.push(CallbackObject);
                            }
                        });
                    }
                }

                $('#LoadIndicator').dxLoadPanel('instance').option('visible', false);
            },
            error: function (data) {
                // The success path hides the load panel at the end; the error path never did,
                // so the shaded "Loading..." panel stayed on top of the error popup and
                // swallowed every click on it - the user had to refresh or close the browser.
                // Hide it here (before the Oops POST, so it goes regardless of that outcome).
                HideLoadingIndicators();

                var ErrorID = Base64.fromInt(new Date().getTime()).substring(2);

                var TheErrorObject = {
                    ID: ErrorID,
                    TheMessage: "Error from /Home/CallBack",
                    StackTrace: "No Stack Trace Available",
                    Location: window.location.href,
                    Browser: window.navigator.appVersion,
                    HTMLCopy: data.responseText,
                    databaseKey: DatabaseKey
                };

                var Output = JSON.stringify(TheErrorObject);
                $.ajax({
                    type: "POST",
                    url: "/Home/Oops?IsPopup=True",
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    data: Output,
                    success: function (response) {
                    },
                    failure: function (response) {
                        alert(response.responseText);
                    },
                    error: function (response) {
                        var date = new Date();

                        $("#ErrorPopup").dxPopup({
                            contentTemplate: function (contentElement) {
                                contentElement.append(response.responseText);
                            },
                            showTitle: true,
                            title: "Error: " + ErrorID + " " + date.toLocaleTimeString() + " " + date.toLocaleDateString(),
                            height: "auto",
                            visible: true,
                            showCloseButton: false
                        });
                    }
                });
            }
        });
    }
}
var SendButtonCallbackName;
function SendButton() {

    var IDS = [];
    RequestingGrid = "VehicleJobGrid";
    var Rows = $("#VehicleJobGrid").dxDataGrid("instance").getVisibleRows();
    SendButtonCallbackName = ResourceRowHeadertext;

    for (var i = 0; i < Rows.length; i++) {
        IDS.push(Rows[i].data.DatabaseID);
    }

    ViewCallback(IDS.join(", "), "SendJobs", "TruckcomModel.StcVehicleJobDataset, TruckcomModel", "SendButtonCallbackName", "ViewPopup", "false", "", new Date(), new Date());
    $("#Send").dxButton("instance").option("disabled", true);
    $("#UnSend").dxButton("instance").option("disabled", false);
}

function UnSendButton() {

    var IDS = [];
    RequestingGrid = "VehicleJobGrid";
    var Rows = $("#VehicleJobGrid").dxDataGrid("instance").getVisibleRows();
    SendButtonCallbackName = ResourceRowHeadertext;

    for (var i = 0; i < Rows.length; i++) {
        IDS.push(Rows[i].data.DatabaseID);
    }

    ViewCallback(IDS.join(", "), "UnSendJobs", "TruckcomModel.StcVehicleJobDataset, TruckcomModel", "SendButtonCallbackName", "ViewPopup", "false", "", new Date(), new Date());
    $("#UnSend").dxButton("instance").option("disabled", true);
    $("#Send").dxButton("instance").option("disabled", false);
}

function SendLegs() {

    var IDS = [];
    RequestingGrid = "VehicleLegGrid";
    var Rows = $("#VehicleLegGrid").dxDataGrid("instance").getVisibleRows();

    for (var i = 0; i < Rows.length; i++) {
        IDS.push(Rows[i].data.DatabaseID);
    }

    // The resource pane dataset also loads dedicated depot stops, which have no customer job.
    ViewCallback(IDS.join(", "), "SendLegsCallback", "TruckcomModel.StcVehicleLegDataset, TruckcomModel", "", "ViewPopup", "false", "", new Date(), new Date());
}

function GetResizablePopup_MapSize(mapId) {
    var height = $(mapId).parents(".Truckcom_Grid_Map_Container ").height();
    return height;
}

/* Utility Functions */
function htmlDecode(input) {
    var txt = document.createElement('textarea');
    txt.innerHTML = input;
    return txt.value;
}

function isNumber(e, allowDecimals, tPrefixAllowed) {
    var regex;
    var charCode = e.event.key;

    if (tPrefixAllowed !== undefined) {
        if (allowDecimals) {
            regex = /^[tT0-9.,-]+$/;
        }
        else {
            regex = /^[tT0-9]+$/;
        }
    }
    else {
        if (allowDecimals) {
            regex = /^[0-9.,-]+$/;
        }
        else {
            regex = /^[0-9]+$/;
        }
    }    

    if (!regex.test(charCode)) {
        e.event.preventDefault();
        return false;
    }

    return true;
}

function isDecimalStrict(e) {
    var regex = /^[0-9.]+$/;
    var charCode = e.event.key;

    if (!regex.test(charCode)) {
        e.event.preventDefault();
        return false;
    }

    return true;
}

function isDecimalStrictPasted(value) {
    return value.replace(/[^\d.]/g, '')
}

// Number columns are shown to two decimal places unless listed here or set by the property (column.DecimalPlaces).
// A price per mile is negotiated to three (56096) - rounding it to two both hid
// the agreed rate and wrote the rounded figure back when the cell was edited.
var ThreeDecimalPlaceColumns = ["PricePerMile"];

function DecimalPlacesForColumn(columnName, column) {
    if (column && column.DecimalPlaces != null) return column.DecimalPlaces;
    return ThreeDecimalPlaceColumns.indexOf(columnName) > -1 ? 3 : 2;
}

// Picking a Vehicle Type on a vehicle form (TcvAutoForm or _EditLayout) fills its blank or zero Capacity
// boxes from the VehicleTypeCapacityDefaults setting. A typed value is left alone; one filled here
// follows the type until the user edits it. Only boxes on the form are filled.
function ApplyVehicleTypeCapacityDefaults(form, defaults, filled, vehicleType) {
    var typeDefaults = defaults[vehicleType] || {};
    var formData = form.dxForm("instance").option("formData");

    $.each(["CapacityWeight", "CapacitySpaces"], function (index, field) {
        var numberBox = form.find("div[fieldname='" + field + "']");
        var current = formData[field] || 0;
        var value = typeDefaults[field] || 0;

        if (numberBox.length === 0 || value === current || (current !== 0 && current !== filled[field])) {
            return;
        }

        // The box's own onValueChanged stores the number and records the change.
        numberBox.dxTextBox("instance").option("value", Globalize.formatNumber(value));
        filled[field] = value;
    });
}

function isIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > -1 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer
    {
        return true;
    }

    return false;
}

function isEdge() {
    if (navigator.userAgent.indexOf("Edge") > -1) {
        return true;
    }

    return false;
}

function hexToRgbA(hex) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',0.5)';
    }
    throw new Error('Bad Hex');
}

function sortByThenBy(array, keys) {
    return array.sort(function (a, b) {
        var r = 0;
        keys.some(function (k) {
            return r = a[k] - b[k];
        });
        return r;
    });
}

function findWithAttr(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
            return i;
        }
    }
    return -1;
}

function GetGridSavedDates(Client_Grid_ID) {
    var savedStartDate = sessionStorage.getItem(Client_Grid_ID + "StartDate");

    var savedEndDate = sessionStorage.getItem(Client_Grid_ID + "EndDate");
    var startDate;
    var endDate;

    if (savedStartDate != null) {
        startDate = new Date(savedStartDate);
    }
    else {
        startDate = new Date();
    }

    if (savedEndDate != null) {
        endDate = new Date(savedEndDate);
    }
    else {
        endDate = new Date();
    }

    var startDateString = startDate.getFullYear() + "-" + ('0' + (startDate.getMonth() + 1)).slice(-2) + "-" + ('0' + startDate.getDate()).slice(-2);
    var endDateString = endDate.getFullYear() + "-" + ('0' + (endDate.getMonth() + 1)).slice(-2) + "-" + ('0' + endDate.getDate()).slice(-2);

    return [startDateString, endDateString];
}

function NewAddressFinished(e) {
    setTimeout(function () {
        if ($("#SelectorPopupDatagrid").children().length > 0) {
            $("#SelectorPopupDatagrid").dxDataGrid("instance").selectRowsByIndexes(e.CallbackResult);
            SelectorPopupDatagrid_SelectedID = $("#SelectorPopupDatagrid").dxDataGrid("instance").getKeyByRowIndex(e.CallbackResult);
        }
    }, 500);

}

// Guarantees a clean #NotesEditor host before one is built.
//
// The bug this fixes: clicking a second "..." while another field's popover was still
// OPEN re-entered CreateNotesPopoverEditor with #NotesEditor still in the DOM and still
// owning a LIVE dxPopover. It then (a) appended a duplicate #NotesTextBox /
// #NotesEditorButtons into it, (b) re-parented the live overlay's own root element via
// appendTo("body"), and (c) re-configured that existing instance — visible + a new target
// — instead of constructing a new widget. DevExtreme threw inside _renderVisibility
// ("Cannot read properties of null (reading 'onShowing')") and the popover was destroyed,
// so the second field's editor never appeared. Reproduced and fixed 2026-08-11.
//
// Note the ordinary open -> OK/Cancel -> open path was never affected: dispose empties
// the host and cleans its data, so the old code reused an empty div and nothing
// accumulated. Only the overlapping case left a LIVE host behind. Shared by nine call sites
// (_EditLayout, Datagrid, AutoForm, both pallet forms, the invoice forms, resource grid),
// so the guard lives here rather than in any one caller.
function DisposeNotesPopoverEditor() {
    var $host = $("#NotesEditor");
    if (!$host.length) return;

    var instance = $host.data("dxPopover");
    if (instance) {
        // onHidden disposes as well, so clear it first or teardown re-enters itself.
        try { instance.option("onHidden", null); } catch (e) { }
        try { instance.dispose(); } catch (e) { }
    }
    // dispose() above already removed the overlay's own wrapper, wherever DX parented
    // it; this just clears the now-empty host.
    $host.remove();
}

// standingNotes is an optional array of {source, text} rendered read-only ABOVE the editable box (the
// customer's and the addresses' Notes For Jobs, from the jobs grid). Above, because the box below is the
// one OK saves. One titled panel per source, so the heading says whose note it is at a glance; only the
// jobs grid passes it, every other call site omits it and gets the editable box alone.
function CreateNotesPopoverEditor(existingValue, editorTextBox, saveOnClickFunction, standingNotes) {
    DisposeNotesPopoverEditor();
    // The Truckcom_Popup_Container class is what makes insertListener (below) lift this
    // popover above any open popup: the nodeInserted keyframe in Truckcom_Common.scss only
    // targets .Truckcom_Popup_Container > .dx-overlay-wrapper, and DevExtreme parents an
    // overlay's wrapper inside its own host element. Drop the class and the popover keeps
    // DevExtreme's own z-index, which sits below a popup that insertListener has lifted.
    $("body").append($("<div id='NotesEditor' class='Truckcom_Popup_Container'></div>"));

    var hasStandingNotes = $.isArray(standingNotes) && standingNotes.length > 0;

    if (hasStandingNotes) {
        // One height budget SHARED across the panels, not the SCSS cap each: .dx-popup-content is
        // overflow:hidden, so a popover taller than the viewport clips the OK button off instead of
        // scrolling to it, and the planner cannot save at all.
        var panelMaxHeight = Math.floor(320 / standingNotes.length);

        // A heading per source, not one generic heading: it is what tells the planner whose note this is,
        // and what stops the block reading as a second editable field.
        $.each(standingNotes, function (i, note) {
            $("#NotesEditor")
                .append($("<div/>").addClass("Truckcom_StandingNoteHeading").text(note.source + " notes (read only)"))
                .append($("<div/>").addClass("Truckcom_ReadOnlyNotes").css("max-height", panelMaxHeight + "px").text(note.text));
        });

        // The editable box is titled only when something sits above it to tell it apart from; alone in
        // the popover it needs no label, which is what every non-jobs-grid caller gets.
        $("#NotesEditor").append($("<div/>").addClass("Truckcom_StandingNoteHeading").text("Job Notes"));
    }

    var notesPopover = $("#NotesEditor").append(
        $("<div/>").attr("id", "NotesTextBox").dxTextArea({
            width: 400,
            height: 200,
            value: existingValue
        }))
        .append(
            $("<div/>").attr("id", "NotesEditorButtons").attr("class", "Truckcom_Popup_ButtonContainer_NoMarginBottom")
                .append(
                    $("<div/>").attr("id", "NotesEditorOK").dxButton({
                        text: "OK",
                        type: "default",
                        elementAttr: {
                            class: "Truckcom_Button"
                        },
                        onClick: function () {
                            eval(saveOnClickFunction);
                        }
                    }))
                .append(
                    $("<div/>").attr("id", "NotesEditorCancel").dxButton({
                        text: "Cancel",
                        elementAttr: {
                            class: "Truckcom_Button"
                        },
                        onClick: function () {
                            $("#NotesEditor").dxPopover("instance").dispose();
                        }
                    }))
        );

    $("#NotesEditor").dxPopover({
        visible: true,
        target: editorTextBox,
        onShown: function () {
            $("#NotesTextBox .dx-texteditor-input-container").height(200);

            $("#NotesTextBox .dx-texteditor-input").focus();
        },
        onHidden: function () {
            $("#NotesEditor").dxPopover("instance").dispose();
        }
    });
}

function SaveNotesEditorValue(formId, dataField) {
    var newTextValue = $("#NotesTextBox").dxTextArea("instance").option("value");
    $("#" + formId + " .dx-textbox[fieldname='" + dataField + "']").dxTextBox("instance").option("value", newTextValue);    // Set the textbox field value in the form

    $("#" + formId).dxForm("instance").option("formData." + dataField, newTextValue);
    $("#NotesEditor").dxPopover("instance").dispose();
    $("#" + formId + " .dx-texteditor-input[datafield='" + dataField + "']").focus();
}

// Listens for node inserted events of dx-overlay-wrapper class and sets z-index of newly added divs
var insertListener = function (event) {
    if (event.animationName == "nodeInserted") {
        if ($(event.target).hasClass("dx-overlay-wrapper")) {
            var maxZ = getMaxZ($(".dx-overlay-wrapper:not('.dx-toast-wrapper')"));

            $(event.target).css("z-index", maxZ + 1);
            $(event.target).find(".dx-overlay-content").css("z-index", maxZ + 100);
        } else if ($(event.target).hasClass("dx-toast") || $(event.target).hasClass("dx-dialog")) {
            $(event.target).find(".dx-toast-wrapper").css("z-index", 9999);
            $(event.target).find(".dx-toast-content").css("z-index", 9999);
        }
    }
};

// Get the highest z-index of the selector provided
var getMaxZ = function (selector) {
    return Math.max.apply(null, $(selector).map(function () {
        var z;
        return isNaN(z = parseInt($(this).css("z-index"), 10)) ? 0 : z;
    }));
};

function PrintResourcePaperwork(methodName) {
    var ids = ResourcePane_SelectedResourceIds();
    if (ids.length === 0) return false;

    RequestingGrid = "ProfitCentreGrid";
    SendButtonCallbackName = ResourceRowHeadertext;
    // The callback's dataset can load in its own sort order. Carry the selection order
    // in the model as well so the server can put the resources back in that order.
    var orderedIds = ids.join(",");
    // ParentID3 carries the grid's override-date mode, so the paperwork prints the legs the grid shows
    ViewCallback(orderedIds, methodName, "TruckcomModel.StcSearchableProfitCentreDataset, TruckcomModel", JSON.stringify(orderedIds), "ViewPopup", "false", "", ProfitCentreGrid_StartDate, ProfitCentreGrid_EndDate,
        undefined, undefined, undefined, window["ProfitCentreGrid_ParentID3"]);
    return true;
}

function PrintRunsheet(databaseKey) {
    if (!PrintResourcePaperwork("PrintResourceRunsheets")) return;

    if (databaseKey.toUpperCase() == "SIMARCO") {
        ShowBarcodes(databaseKey);
        PrintLabels(databaseKey);
    }
}

function PrintRunsheetLeg(e) {
    if (ResourcesGridIsOnPage()) {
        PrintResourcePaperwork("PrintResourceRunsheets");
        return;
    }

    // Keep the existing load-management callback separate from resource selection.
    RequestingGrid = "ProfitCentreGrid";
    SendButtonCallbackName = ResourceRowHeadertext;
    ViewCallback([VehicleLegGrid_ParentID].join(","), "PrintRunSheetLeg", "TruckcomModel.StcSearchableProfitCentreDataset, TruckcomModel", "", "ViewPopup", "false", "", ProfitCentreGrid_StartDate, ProfitCentreGrid_EndDate,
        undefined, undefined, undefined, window["VehicleLegGrid_ParentID3"]);
}

function PrintLoadList(e) {
    PrintResourcePaperwork("PrintResourceLoadLists");
}

function PrintCombinedPaperwork(e) {
    PrintResourcePaperwork("PrintResourcePaperwork");
}

function PrintRunsheetWithDocuments(e) {
    PrintResourcePaperwork("PrintResourceRunsheetsWithDocuments");
}

function PrintLabels(e) {
    var IDS = [];
    RequestingGrid = "ProfitCentreGrid";

    IDS.push(VehicleJobGrid_ParentID);
    ViewCallback(IDS.join(", "), "PrintJobLabels", "TruckcomModel.StcSearchableProfitCentreDataset, TruckcomModel", "", "ViewPopup", "false", "", ProfitCentreGrid_StartDate, ProfitCentreGrid_EndDate);
}

function ShowBarcodes(e) {
    var IDS = [];
    RequestingGrid = "ProfitCentreGrid";

    IDS.push(VehicleJobGrid_ParentID);
    ViewCallback(IDS.join(", "), "ShowJobBarcodes", "TruckcomModel.StcSearchableProfitCentreDataset, TruckcomModel", "", "ViewPopup", "false", "", ProfitCentreGrid_StartDate, ProfitCentreGrid_EndDate);
}

function AddNote(e) {
    var IDS = [];
    RequestingGrid = "ProfitCentreGrid";
    SendButtonCallbackName = ResourceRowHeadertext;

    IDS.push(VehicleLegGrid_ParentID);
    ViewCallback(IDS.join(", "), "AddNotesJobXT", "TruckcomModel.StcSearchableProfitCentreDataset, TruckcomModel", "", "ViewPopup", "false", "", ProfitCentreGrid_StartDate, ProfitCentreGrid_EndDate);
}

function AddDepot(e) {
    var IDS = ResourcesGridIsOnPage() ? ResourcePane_SelectedResourceIds() : [VehicleLegGrid_ParentID];
    if (IDS.length !== 1 || IDS[0] !== VehicleLegGrid_ParentID) return;

    var legsGrid = $("#VehicleLegGrid").dxDataGrid("instance");
    var selectedLegIds = legsGrid ? legsGrid.getSelectedRowKeys() : [];
    var afterLegId = selectedLegIds.length === 1 ? selectedLegIds[0] : 0;

    RequestingGrid = "ProfitCentreGrid";
    // ViewCallback evaluates its model argument: pass a quoted string literal, never a row expression.
    ViewCallback(IDS.join(", "), "AddDepotLegXT", "TruckcomModel.StcSearchableProfitCentreDataset, TruckcomModel", JSON.stringify(String(afterLegId)), "ViewPopup", "false", "ReloadVehicleLegsAndRunEtas(" + parseInt(IDS[0], 10) + ")", ProfitCentreGrid_StartDate, ProfitCentreGrid_EndDate,
        undefined, undefined, undefined, window["VehicleLegGrid_ParentID3"]);
}

function PublishRun(e) {
    ResourcePane_RunAction("PublishRunXT");
}

function SendRun(e) {
    ResourcePane_RunAction("SendRunXT");
}

// Both actions load complete runs on the server for the current resource selection.
function ResourcePane_RunAction(methodName) {
    var IDS = ResourcePane_SelectedResourceIds();
    if (IDS.length === 0) return;

    RequestingGrid = "ProfitCentreGrid";

    // Keep the date-field override used by the displayed run in the pane-below layouts.
    ViewCallback(IDS.join(", "), methodName, "TruckcomModel.StcSearchableProfitCentreDataset, TruckcomModel", "", "ViewPopup", "false", "ReloadResourceRun", ProfitCentreGrid_StartDate, ProfitCentreGrid_EndDate,
        undefined, undefined, undefined, window["VehicleLegGrid_ParentID3"]);
}

function ReloadResourceRun() {
    $("#ProfitCentreGrid").dxDataGrid("getDataSource").reload();
    ReloadVehicleLegs();
}

function ReloadVehicleLegs() {
    $("#VehicleLegGrid").dxDataGrid("getDataSource").reload();

}

// Add Depot Leg: the run it was added to, as the request was sent
function ReloadVehicleLegsAndRunEtas(resourceId) {
    ReloadVehicleLegs();
    if (typeof RecalculateRunEtasAfterChange === "function") RecalculateRunEtasAfterChange([resourceId]);
}

// Multi-edit: a field whose rows differ shows "Multiple values exist" in its picklist button, and option("text")
// adds the new text beside it - so rebuild the content and mark the field changed. Once rebuilt, DX's own text
// node is detached, so later picks on the (now "changed") field must rebuild too. No-op on any other field.
function ReplaceMultiEditPicklistPlaceholder(button, text, formId, dataField) {
    if (button.closest(".Truckcom_MultiEdit_UniqueValueField, .Truckcom_MultiEdit_ValueChanged").length === 0) {
        return;
    }

    button.find(".dx-button-content").empty().append($("<span class='dx-button-text'></span>").text(text));

    if (formId === "AutoForm") {
        if (typeof AutoFormStyleMultiEditFieldChanged === "function") AutoFormStyleMultiEditFieldChanged(dataField);
    } else if (typeof StyleMultiEditFormFieldChanged === "function") {
        StyleMultiEditFormFieldChanged(dataField);
    }
}

function DateSelectorOnClick(data, formId, itemElement, changedValuesName) {
    $("#DateEditor").dxPopover({
        visible: true,
        target: itemElement
    });

    var Dates = [""];
    var DateUndefined = true;
    var theChangedValuesObject = "ChangedValues";

    if (changedValuesName != undefined) {
        theChangedValuesObject = changedValuesName;
    }

    if (data.component.option('formData')[data.dataField].value) {
        Dates = data.component.option('formData')[data.dataField].value.split(',');
        DateUndefined = false;
    }

    SelectorCellInfo = {
        displayValue: data.component.option('formData')[data.dataField]
            .value
    };

    PopoverContent("DateEditor").empty();

    if (Dates.length == 1) {
        var dateValue;

        if (DateUndefined) {
            dateValue = new Date();
        }
        else {
            dateValue = new Date(Dates[0].substr(6, 4),
                Dates[0].substr(3, 2) - 1,
                Dates[0].substr(0, 2));
        }

        // Multi-edit, rows still differ: open unselected (on the first row's month), or picking the date
        // the calendar opened on would not count as a change
        var multiEditUnset = $(itemElement).closest(".Truckcom_MultiEdit_UniqueValueField").length > 0;

        PopoverContent("DateEditor").append($("<div id='Date0'>").dxCalendar({
            value: multiEditUnset ? null : dateValue,
            currentDate: dateValue,
            onValueChanged: function (e) {
                data.component.option('formData')[data.dataField].value = Globalize("en-GB").dateFormatter()(e.value);

                var dateText = Globalize("en-GB").dateFormatter()(e.value);
                var dateButton = $("#" + formId + " .dx-field-item-content[fieldname='" + data.dataField + "'] .Truckcom_Form_Picklist_Button");
                dateButton.dxButton("instance").option("text", dateText);
                ReplaceMultiEditPicklistPlaceholder(dateButton, dateText, formId, data.dataField);

                window[theChangedValuesObject].push(data.dataField);
                $("#DateEditor").dxPopover("dispose");
                itemElement.find(".dx-button").focus();
            },
            showTodayButton: dateValue.getFullYear() == 2008
        }));
    } else {
        var validDates = 0;
        $.each(Dates,
            function (i, theDate) {
                theDate = theDate.replace(' ', '');

                if (theDate !== "") {
                    var dateValue = new Date(theDate.substr(6, 4),
                        theDate.substr(3, 2) - 1,
                        theDate.substr(0, 2));

                    PopoverContent("DateEditor").append($("<div id='Date" + i + "' class='Truckcom_MultiDate_Selector'>").dxCalendar({
                        value: dateValue
                    }));

                    validDates++;
                }
            });

        var margins = validDates * 20;
        PopoverContent("DateEditor").width((validDates * 232) + margins);

        PopoverContent("DateEditor").append($("<div class='Truckcom_Popup_ButtonContainer_NoMarginBottom'>")
            .append($("<div id='DateOK' class='Truckcom_Button'>").dxButton({
                type: "default",
                text: "OK",
                onClick: function (e) {
                    var Count = data.component.option('formData')[data.dataField].value.split(',').length;
                    var TheDateArray = [];
                    for (var j = 0; j < Count; j++) {
                        TheDateArray.push(Globalize("en-GB").dateFormatter()($("#Date" + j).dxCalendar("instance")
                            .option("value")));
                    }

                    var NewValue = TheDateArray.join(', ');
                    data.component.option('formData')[data.dataField].value = NewValue;

                    var datesButton = $("#" + formId + " .dx-field-item-content[fieldname='" + data.dataField + "'] .Truckcom_Form_Picklist_Button");
                    datesButton.dxButton("instance").option("text", NewValue);
                    ReplaceMultiEditPicklistPlaceholder(datesButton, NewValue, formId, data.dataField);

                    window[theChangedValuesObject].push(data.dataField);
                    $("#DateEditor").dxPopover("dispose");
                }
            }))
            .append($("<div id='DateCancel' class='Truckcom_Button'>").dxButton({
                text: "Cancel",
                onClick: function (e) {
                    $("#DateEditor").dxPopover("dispose");
                }
            })));
    }
}

function FindIndexInArray(items, property, value) {
    var index = -1;

    items.some(function (el, i) {
        if (property !== null) {
            if (el[property] == value) {
                index = i;
                return true;
            }
        } else {
            if (el == value) {
                index = i;
                return true;
            }
        }
    });

    return index;
}

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function (search, this_len) {
        if (this_len === undefined || this_len > this.length) {
            this_len = this.length;
        }
        return this.substring(this_len - search.length, this_len) === search;
    };
}

function CircularBuffer(n) {
    this._array = new Array(n);
    this.length = 0;
}
CircularBuffer.prototype.toString = function () {
    return '[object CircularBuffer(' + this._array.length + ') length ' + this.length + ']';
};
CircularBuffer.prototype.get = function (i) {
    if (i < 0 || i < this.length - this._array.length)
        return undefined;
    return this._array[i % this._array.length];
};
CircularBuffer.prototype.set = function (i, v) {
    if (i < 0 || i < this.length - this._array.length)
        throw CircularBuffer.IndexError;
    while (i > this.length) {
        this._array[this.length % this._array.length] = undefined;
        this.length++;
    }
    this._array[i % this._array.length] = v;
    if (i == this.length)
        this.length++;
};

CircularBuffer.prototype.push = function (v) {
    this._array[this.length % this._array.length] = v;
    this.length++;
};

CircularBuffer.prototype.getAll = function () {
    return this._array;
};

CircularBuffer.IndexError = {};


function IsNullorUndefined(element) {
    return (element === undefined || element === null);
}

function CreateHtmlEditor(editorId, editorVariable, heightToSet) {
    ClassicEditor
        .create(document.querySelector("#" + editorId), {

            toolbar: {
                items: [
                    'heading',
                    '|',
                    'bold',
                    'italic',
                    'underline',
                    'link',
                    'bulletedList',
                    'numberedList',
                    'insertTable',
                    '|',
                    'undo',
                    'redo'
                ]
            },
            language: 'en',
            // The bundled build ships the Image and Table widget plugins; leaving their
            // widget toolbars without items logs a widget-toolbar-no-items warning per
            // editor create. Give both a minimal toolbar instead.
            table: {
                contentToolbar: [
                    'tableColumn',
                    'tableRow',
                    'mergeTableCells'
                ]
            },
            image: {
                toolbar: [
                    'imageTextAlternative'
                ]
            }
        })
        .then(function (newEditor) {
            HtmlEditors[editorId] = newEditor;
            heightToSet -= 40; // Html editor toolbar height
            $(".ck-editor__main").height(heightToSet);
        });
}

function CreatePicker(cellElement, data, formId) {

    if (data === undefined) {
        data = "";
    }

    if (formId === undefined) {
        formId = "";
    }

    var picker = $("<div />").attr({ "id": "TruckcomTimePicker", "class": "Truckcom_Plugin_TimePicker" });

    // Create the time picker tab options with click event
    var pickerTabs = $("<ul />").attr("class", "Truckcom_Plugin_TimePicker_Tabs")
        .append($("<li />").attr({ "class": "Truckcom_Plugin_TimePicker_TabActive dx-button-default dx-button-mode-contained", "id": "time" }).text("HH:MM"))
        .append($("<li />").attr("id", "am").text("AM"))
        .append($("<li />").attr("id", "pm").text("PM"))
        .append($("<li />").attr("id", "tba").text("TBA"))

    $(document).on("click", ".Truckcom_Plugin_TimePicker_Tabs li", function () {
        TimePicker_Tab_Click($(this));
    });

    picker.append(pickerTabs);

    var entryTab = CreateTimePickerEntryTab(data, formId);
    picker.append(entryTab);

    var amTab = CreateTimePickerAMTab(data, formId);
    picker.append(amTab);

    var pmTab = CreateTimePickerPMTab(data, formId);
    picker.append(pmTab);

    var tbaTab = CreateTimePickerTBATab(data, formId);
    picker.append(tbaTab);

    SetupClickEvents(cellElement, data, formId);

    return picker;
}

function SetupClickEvents(cellElement, data, formId) {
    var gridId = "";

    if (cellElement !== "") {
        if (cellElement.parents(".Truckcom_Data_Grid").attr("id") !== undefined) {
            gridId = cellElement.parents(".Truckcom_Data_Grid").attr("id").replace("_Datagrid", "");
        }
    }

    $(document).on("click", "#TimeOK", function () {
        TimePickerOK_Clicked(data, formId, gridId);
        $(document).off("click", "#TimeOK");
        $(document).off("click", "#TimeCancel");
        $(document).off("click", ".Truckcom_Plugin_TimePicker_TimeButton.CloseOnSet");
        $(document).off("click", ".Truckcom_Plugin_TimePicker_TimeButton.MinuteButton");
        $(document).off("click", ".Truckcom_Plugin_TimePicker_TimeButton.HourButton");
    });

    $(document).on("click", "#TimeCancel", function () {
        CloseTimePicker(gridId);
        $(document).off("click", "#TimeCancel");
        $(document).off("click", "#TimeOK");
        $(document).off("click", ".Truckcom_Plugin_TimePicker_TimeButton.CloseOnSet");
        $(document).off("click", ".Truckcom_Plugin_TimePicker_TimeButton.MinuteButton");
        $(document).off("click", ".Truckcom_Plugin_TimePicker_TimeButton.HourButton");
    });

    $(document).on("mouseenter", ".Truckcom_Plugin_TimePicker_TimeButton", function () {
        $(this).addClass("dx-state-hover");
    });

    $(document).on("mouseleave", ".Truckcom_Plugin_TimePicker_TimeButton", function () {
        $(this).removeClass("dx-state-hover");
    });

    $(document).on("click", ".Truckcom_Plugin_TimePicker_TimeButton.HourButton", function () {
        $(this).parent().find(".dx-calendar-selected-date").removeClass("dx-calendar-selected-date");
        $(this).addClass("dx-calendar-selected-date");
        TimePickerSetValue($(this).text(), "#Hour");
    });

    $(document).on("click", ".Truckcom_Plugin_TimePicker_TimeButton.MinuteButton", function () {
        $(this).parent().find(".dx-calendar-selected-date").removeClass("dx-calendar-selected-date");
        $(this).addClass("dx-calendar-selected-date");
        TimePickerSetValue($(this).text(), "#Minute");
    });

    $(document).on("click", ".Truckcom_Plugin_TimePicker_TimeButton.CloseOnSet", function () {
        $(this).parent().find(".dx-calendar-selected-date").removeClass("dx-calendar-selected-date");
        $(this).addClass("dx-calendar-selected-date");
        TimePickerValueChosen($(this), data, formId, gridId);
        $(document).off("click", "#TimeCancel");
        $(document).off("click", "#TimeOK");
        $(document).off("click", ".Truckcom_Plugin_TimePicker_TimeButton.CloseOnSet");
        $(document).off("click", ".Truckcom_Plugin_TimePicker_TimeButton.MinuteButton");
        $(document).off("click", ".Truckcom_Plugin_TimePicker_TimeButton.HourButton");
    });

    $(document).on("keyup", "#TimePickerInput", function () {
        TimePickerInput_KeyUp($(this));
    });
}

function CreateTimePickerEntryTab(data, formId) {
    var entryTimePickerTab = $("<div />").attr({ "id": "timeContent", "class": "Truckcom_Plugin_TimePicker_TabContent Truckcom_Plugin_TimePicker_TabContentActive" });

    entryTimePickerTab.append($("<div />").attr("class", "Truckcom_TimeUpdate_TimeBox dx-texteditor dx-editor-outlined Truckcom_TimePicker dx-widget")
        .append($("<div />").attr("class", "dx-texteditor-container")
            .append($("<input />").attr({ "id": "TimePickerInput", "class": "dx-texteditor-input" }))));

    entryTimePickerTab.append($("<p />").text("Hour"));

    var hourContainer = $("<div/>");

    for (var i = 0; i < 24; i++) {
        hourContainer.append($("<div />")
            .attr("class", "Truckcom_Plugin_TimePicker_TimeButton HourButton dx-calendar-cell")
            .text(Pad(i, 2)));
    }

    entryTimePickerTab.append(hourContainer);
    entryTimePickerTab.append($("<p />").text("Minute"));

    var minuteContainer = $("<div/>");

    for (var i = 0; i < 12; i++) {
        minuteContainer.append($("<div />")
            .attr("class", "Truckcom_Plugin_TimePicker_TimeButton MinuteButton dx-calendar-cell")
            .text(Pad(i * 5, 2)));
    }

    entryTimePickerTab.append(minuteContainer);

    var timePickerButtons = $("<div />").attr("class", "Truckcom_Plugin_TimePicker_Button_Container")
        .append($("<div />")
            .attr({ "id": "TimeOK", "class": "Truckcom_Plugin_TimePicker_Button dx-button dx-button-default dx-button-mode-contained dx-widget" })
            .css("pointer-events", "none")
            .append($("<div />").attr("class", "dx-button-content").text("OK")))
        .append($("<div />")
            .attr({ "id": "TimeCancel", "class": "Truckcom_Plugin_TimePicker_Button dx-button dx-button-normal dx-button-mode-contained dx-widget" })
            .append($("<div />").attr("class", "dx-button-content").text("Cancel")));

    var selectedTimeArea = $("<div />").attr("class", "Truckcom_Plugin_TimePicker_SelectedTime")
        .append($("<input />").attr("id", "TimePickerChosenValue").css("display", "none"))
        .append($("<span />").attr("id", "Hour"))
        .append($("<span />").text(":"))
        .append($("<span />").attr("id", "Minute"))
        .append(timePickerButtons)

    entryTimePickerTab.append(selectedTimeArea);

    return entryTimePickerTab;
}

function CreateTimePickerAMTab(data, formId) {
    var amTab = $("<div />").attr({ "id": "amContent", "class": "Truckcom_Plugin_TimePicker_TabContent" });

    for (var i = 0; i < 12; i++) {
        for (var x = 0; x < 4; x++) {
            amTab.append($("<div />")
                .attr("class", "Truckcom_Plugin_TimePicker_TimeButton CloseOnSet dx-calendar-cell")
                .text(Pad(i, 2) + ":" + Pad(x * 15, 2)));
        }
    }

    return amTab;
}

function CreateTimePickerPMTab(data, formId) {
    var pmTab = $("<div />").attr({ "id": "pmContent", "class": "Truckcom_Plugin_TimePicker_TabContent" });

    for (var i = 12; i < 24; i++) {
        for (var x = 0; x < 4; x++) {
            pmTab.append($("<div />")
                .attr("class", "Truckcom_Plugin_TimePicker_TimeButton CloseOnSet dx-calendar-cell")
                .text(Pad(i, 2) + ":" + Pad(x * 15, 2)));
        }
    }

    return pmTab;
}

function CreateTimePickerTBATab(data, formId) {
    var tbaTab = $("<div />").attr({ "id": "tbaContent", "class": "Truckcom_Plugin_TimePicker_TabContent" });

    tbaTab.append($("<div />")
        .attr("class", "Truckcom_Plugin_TimePicker_TimeButton CloseOnSet dx-calendar-cell")
        .text("23:59"));

    return tbaTab;
}

function CloseTimePicker(gridId) {
    // 26.1 renders popover content in a body-level overlay wrapper, so the host div
    // has no children while open - detect an initialised popover via its instance.
    var timePickerEditorEl = document.getElementById("STTimePickerEditor");
    if (timePickerEditorEl && DevExpress.ui.dxPopover.getInstance(timePickerEditorEl)) {
        $("#TruckcomTimePickerOverlay").remove();
        $("#TruckcomTimePicker").remove();
        $("#STTimePickerEditor").dxPopover("dispose");
    }
    else {
        if (!IsNullorUndefined(gridId)) {
            if ($("#" + gridId + "_TimePickerPopup") !== undefined && $("#" + gridId + "_TimePickerPopup").dxPopover("instance") !== undefined) {
                $("#" + gridId + "_TimePickerPopup").dxPopover("instance").hide();
            }

            var TheObject = {
                TimePickerGrid: gridId,
                Message: "TimePicker Closed",
                time: new Date().toString()
            };

            ClientDialog.push(TheObject);
        }
    }
}

function TimePicker_Tab_Click(tab) {
    var id = tab.attr("id");
    $(".Truckcom_Plugin_TimePicker_TabActive").removeClass("Truckcom_Plugin_TimePicker_TabActive").removeClass("dx-button-default").removeClass("dx-button-mode-contained");
    $(".Truckcom_Plugin_TimePicker_TabContentActive").removeClass("Truckcom_Plugin_TimePicker_TabContentActive");

    $(tab).addClass("Truckcom_Plugin_TimePicker_TabActive").addClass("dx-button-default").addClass("dx-button-mode-contained");
    $("#" + id + "Content").addClass("Truckcom_Plugin_TimePicker_TabContentActive");
}

function TimePickerOK_Clicked(data, formId, gridId) {
    var timeValue = $("#TimePickerChosenValue").val();

    if (data !== "" && formId !== "") {
        TimePickerCloseAndSetForm(timeValue, data, formId, gridId);
    }
    else {
        TimePickerCloseAndSet(timeValue, gridId);
    }
}

function TimePickerSetValue(value, input) {
    var val = Pad(value, 2);
    $(input).text(val);

    $("#TimePickerInput").val("");

    $("#TimePickerChosenValue").val($("#Hour").text().trim() + ":" + $("#Minute").text().trim());
    if ($("#TimePickerChosenValue").val().length === 5) {

        $("#TimeOK").css("pointer-events", "auto");
    }
    else {
        $("#TimeOK").css("pointer-events", "none");
    }
}

function SetTimeValue(hour, minute) {
    $("#Hour").text(hour);
    $("#Minute").text(minute);

    $("#TimePickerInput").val(hour + ":" + minute);

    $("#TimeOK").css("pointer-events", "auto");
}

function TimePickerValueChosen(timeButton, data, formId, gridId) {
    var time = timeButton.text().trim();

    if (data !== "" && formId !== "") {
        TimePickerCloseAndSetForm(time, data, formId);
    }
    else {
        TimePickerCloseAndSet(time, gridId);
    }
}

function TimePickerCloseAndSet(timeValue, gridId) {
    // Leave edit mode before setting the value: 26.1 re-runs the edit template when the save lands,
    // which left the cell showing the old time (#56607)
    var grid = TimePickerCellInfo.component;
    var rowIndex = grid.getRowIndexByKey(TimePickerCellInfo.key);
    if (rowIndex >= 0) {
        grid.cancelEditData();
        grid.cellValue(rowIndex, TimePickerCellInfo.column.dataField, timeValue);
    } else {
        TimePickerCellInfo.setValue(timeValue);
    }
    grid.saveEditData();

    CloseTimePicker(gridId);
}

function TimePickerCloseAndSetForm(timeValue, dataField, formId, gridId) {
    if ($("#" + formId).hasClass("dx-form")) {
        $("#" + formId).dxForm("instance").option('formData')[dataField] = timeValue;
        var timeButton = $("#" + formId + " .dx-field-item-content[fieldname='" + dataField + "'] .Truckcom_Form_Picklist_Button");
        timeButton.dxButton("instance").option("text", timeValue);
        ReplaceMultiEditPicklistPlaceholder(timeButton, timeValue, formId, dataField);
    }
    else {
        $("#" + formId + " #" + dataField + " .Truckcom_Form_Picklist_Button").dxButton("instance").option("text", timeValue);
    }

    var theChangedValues = "ChangedValues";

    if (formId == "AutoForm") {
        theChangedValues = "AutoFormChangedValues";
    }

    if (typeof window[theChangedValues] !== "undefined") {
        window[theChangedValues].push(dataField);
    }

    CloseTimePicker(gridId);
}

function TimePickerInput_KeyUp(input) {
    if (input.val().length === 5) {
        $("#TimePickerChosenValue").val(input.val());
        $("#Hour").text(input.val().substring(0, 2));
        $("#Minute").text(input.val().substring(3));

        $("#TimeOK").css("pointer-events", "auto");
    }
    else {
        $("#TimeOK").css("pointer-events", "none");
    }
}

function Pad(str, max) {
    str = str.toString();
    return str.length < max ? Pad("0" + str, max) : str;
}

function CreateDataGrid(dataGridProperties) {
    if (dataGridProperties.GridId !== undefined && dataGridProperties.GridId !== "" &&
        dataGridProperties.Dataset !== undefined && dataGridProperties.Dataset !== "" &&
        dataGridProperties.DataSetType !== undefined && dataGridProperties.DataSetType !== "" &&
        dataGridProperties.StartDate !== undefined && dataGridProperties.StartDate !== "" &&
        dataGridProperties.EndDate !== undefined && dataGridProperties.EndDate !== "") {

        if (dataGridProperties.LegacyColumnNames == undefined) {
            dataGridProperties.LegacyColumnNames = "";
        }

        if (dataGridProperties.CustomSearchText == undefined) {
            dataGridProperties.CustomSearchText = "";
        }

        if (dataGridProperties.ParentId == undefined) {
            dataGridProperties.ParentId = 0;
        }

        if (dataGridProperties.DatabaseKey == undefined) {
            dataGridProperties.DatabaseKey = "";
        }

        if (dataGridProperties.IsNotColumnSortable == undefined) {
            dataGridProperties.IsNotColumnSortable = false;
        }

        if (dataGridProperties.IsReadOnly == undefined) {
            dataGridProperties.IsReadOnly = false;
        }

        if (dataGridProperties.ColumnLimit == undefined) {
            dataGridProperties.ColumnLimit = 10;
        }

        if (dataGridProperties.ViewName == undefined) {
            dataGridProperties.ViewName = "";
        }

        if (dataGridProperties.SortedByProperties == undefined) {
            dataGridProperties.SortedByProperties = "";
        }

        if (dataGridProperties.RowDragAndDropEnabled == undefined) {
            dataGridProperties.RowDragAndDropEnabled = false;
        }

        if (dataGridProperties.CellDragandDropEnabled == undefined) {
            dataGridProperties.CellDragandDropEnabled = false;
        }

        if (dataGridProperties.IconFilters == undefined) {
            dataGridProperties.IconFilters = [];
        }

        if (dataGridProperties.FilterColumns == undefined) {
            dataGridProperties.FilterColumns = [];
        }

        if (dataGridProperties.RightClicksEnabled == undefined) {
            dataGridProperties.RightClicksEnabled = true;
        }

        if (dataGridProperties.DragCopy == undefined) {
            dataGridProperties.DragCopy = false;
        }

        if (dataGridProperties.HideIconColumn == undefined) {
            dataGridProperties.HideIconColumn = false;
        }

        if (dataGridProperties.ShowRowLines == undefined) {
            dataGridProperties.ShowRowLines = false;
        }

        if (dataGridProperties.ShowColumnLines == undefined) {
            dataGridProperties.ShowColumnLines = true;
        }

        if (dataGridProperties.PropertiesToShow == undefined) {
            dataGridProperties.PropertiesToShow = "";
        }

        if (dataGridProperties.MustContain == undefined) {
            dataGridProperties.MustContain = "";
        }

        if (dataGridProperties.SortingMode == undefined) {
            dataGridProperties.SortingMode = "single";
        }

        if (dataGridProperties.CustomDroppedFunction == undefined) {
            dataGridProperties.CustomDroppedFunction = "";
        }

        if (dataGridProperties.ContentReadyFunction == undefined) {
            dataGridProperties.ContentReadyFunction = "";
        }

        if (dataGridProperties.SetGridSize == undefined) {
            dataGridProperties.SetGridSize = false;
        }

        if (dataGridProperties.UseStandardScrolling == undefined) {
            dataGridProperties.UseStandardScrolling = false;
        }

        if (dataGridProperties.EnableFocusedRow == undefined) {
            dataGridProperties.EnableFocusedRow = false;
        }

        if (dataGridProperties.DropAtAnyPosition == undefined) {
            dataGridProperties.DropAtAnyPosition = false;
        }

        if (dataGridProperties.AutoSortProperty == undefined) {
            dataGridProperties.AutoSortProperty = "";
        }

        if (dataGridProperties.ImportType == undefined) {
            dataGridProperties.ImportType = "";
        }

        window[dataGridProperties.GridId + "_RowDragandDropEnabled"] = dataGridProperties.RowDragAndDropEnabled;
        window[dataGridProperties.GridId + "_CellDragandDropEnabled"] = dataGridProperties.CellDragAndDropEnabled;

        window[dataGridProperties.GridId + "_StartDate"] = dataGridProperties.StartDate;
        window[dataGridProperties.GridId + "_EndDate"] = dataGridProperties.EndDate;
        window[dataGridProperties.GridId + "_SelectorDatasetType"] = dataGridProperties.DataSetType;
        window[dataGridProperties.GridId + "_SelectorDataset"] = dataGridProperties.Dataset;
        window[dataGridProperties.GridId + "_IsNotColumnSortable"] = dataGridProperties.IsNotColumnSortable;
        window[dataGridProperties.GridId + "_SortedByProperties"] = dataGridProperties.SortedByProperties;
        window[dataGridProperties.GridId + "_ParentID"] = dataGridProperties.ParentId;
        window[dataGridProperties.GridId + "_AlwaysDragCopy"] = dataGridProperties.DragCopy;
        window[dataGridProperties.GridId + "_SearchText"] = dataGridProperties.SearchText;
        window[dataGridProperties.GridId + "_CustomDroppedFunction"] = dataGridProperties.CustomDroppedFunction;
        window[dataGridProperties.GridId + "_DatagridInFocusColumnNames"] = dataGridProperties.LegacyColumnNames;
        window[dataGridProperties.GridId + "_IconFilters"] = [];
        window[dataGridProperties.GridId + "_SelectorType"] = dataGridProperties.ObjectType;
        window[dataGridProperties.GridId + "_DropAtAnyPosition"] = dataGridProperties.DropAtAnyPosition;
        window[dataGridProperties.GridId + "_AutoSortProperty"] = dataGridProperties.AutoSortProperty;
        window[dataGridProperties.GridId + "_TimeGenerated"] = { Time: "" };

        var columnProfile = dataGridProperties.ColumnProfile;

        window[dataGridProperties.GridId + "_DataStore"] = new DevExpress.data.AspNet.createStore({
            key: "DatabaseID",
            loadParams: {
                StartDate: function () { return Globalize("en-GB").dateFormatter()(window[dataGridProperties.GridId + "_StartDate"]); },
                EndDate: function () { return Globalize("en-GB").dateFormatter()(window[dataGridProperties.GridId + "_EndDate"]); },
                SearchText: function () { return dataGridProperties.SearchText; },
                CustomSearchText: function () { return dataGridProperties.CustomSearchText; },
                Dataset: dataGridProperties.Dataset,
                ParentID: function () { return window[dataGridProperties.GridId + "_ParentID"]; },
                ParentID2: function () { return dataGridProperties.ParentID2; },
                //SelectedIDs: function () { return @(Model.ClientID) _SelectedID; },
                DataGridName: function () {
                    return dataGridProperties.LegacyColumnNames + dataGridProperties.ViewName;
                },
                PropertiesToShow: function () { dataGridProperties.PropertiesToShow },
                DatabaseKey: dataGridProperties.DatabaseKey,
                MustContain: function () { return dataGridProperties.MustContain; },
                ExtraConstructorParam: function () { return dataGridProperties.ImportType; },
                GridId: function () { return dataGridProperties.GridId; }
            },
            //onBeforeSend: TruckcomGrid_onBeforeSend,
            loadUrl: "/api/AFData",
            dataLoaded: function (updatedGridData, extras) {
                window[dataGridProperties.GridId + "_GridData"] = updatedGridData;
                window[dataGridProperties.GridId + "_GridDataFiltered"] = updatedGridData;
                window[dataGridProperties.GridId + "_GridCount"] = window[dataGridProperties.GridId + "_GridDataFiltered"].length;

                window[dataGridProperties.GridId + "_LocalColumns"] = extras.summary[2];

                if (columnProfile == null) { // Done like this so to not break Rail planner etc but so it works for the planning grids
                    columnProfile = extras.summary[2];
                }

                window[dataGridProperties.GridId + "_TimeGenerated"].Time = extras.summary[0];

                // Grids built here - the leg and job planning cell grids, the rail planner - get
                // the same server-built summary spec as every other grid. They render it only if
                // the page gave them somewhere to put it: the cell-grid template's top row holds
                // the resource name and has no id, so today this is a no-op that costs nothing and
                // means adding a "<GridId>_summary" element is all a screen has to do.
                window[dataGridProperties.GridId + "_SummarySpec"] = extras.summary.length > 4 ? extras.summary[4] : null;

                if ($("#" + dataGridProperties.GridId + "_summary").length > 0) {
                    UpdateGridText(dataGridProperties.GridId);
                }
            }
        });

        window[dataGridProperties.GridId + "_DataStore"].update = function (key, values) {
            var e = {
                key: key,
                newData: values
            };

            return DataGrid_updating(e, dataGridProperties.GridId);
        };

        var TruckcomGrid_dataSource = new DevExpress.data.DataSource({
            store: window[dataGridProperties.GridId + "_DataStore"],
            pushAggregationTimeout: 100,
            requireTotalCount: true,
            reshapeOnPush: !dataGridProperties.IsNotColumnSortable
        });

        var defaultScrollingProperties = {
            mode: "infinite",
            showScrollbar: "always",
            useNative: true,
            preloadEnabled: true,
        };

        var scrollingProps = {};

        if (dataGridProperties.UseStandardScrolling) {
            scrollingProps = defaultScrollingProperties;
        }

        $("#" + dataGridProperties.GridId).dxDataGrid({
            dataSource: TruckcomGrid_dataSource,
            showBorders: true,
            showRowLines: dataGridProperties.ShowRowLines,
            sorting: {
                mode: dataGridProperties.SortingMode
            },
            customizeColumns: function (e) {
                DataGridRenderColumns(
                    e,
                    dataGridProperties.GridId,
                    dataGridProperties.IsReadOnly,
                    dataGridProperties.ColumnLimit,
                    dataGridProperties.Dataset,
                    dataGridProperties.LegacyColumnNames,
                    dataGridProperties.StartDate,
                    dataGridProperties.EndDate,
                    dataGridProperties.PropertiesToShow,
                    dataGridProperties.DatabaseKey,
                    dataGridProperties.ViewName,
                    dataGridProperties.IconFilters,
                    dataGridProperties.FilterColumns,
                    dataGridProperties.HideIconColumn,
                    dataGridProperties.ParentId,
                    false,
                    columnProfile
                );
            },
            onContextMenuPreparing: function (e) {
                if (dataGridProperties.RightClicksEnabled) {
                    RightClickMenu(e, dataGridProperties.GridId);
                }
            },
            onContentReady: function (e) {
                if (window[dataGridProperties.GridId + "_RowDragandDropEnabled"] || window[dataGridProperties.GridId + "_CellDragandDropEnabled"]) {
                    $("#" + dataGridProperties.GridId).addClass("Truckcom_DragAndDrop");
                    SetupDragandDrop();
                }

                if (dataGridProperties.ContentReadyFunction !== "") {
                    window[dataGridProperties.ContentReadyFunction](e);
                }

            },
            onRowPrepared: function (e) {
                RowPrepared(e);
                if (dataGridProperties.RowPrepared !== undefined) {
                    dataGridProperties.RowPrepared(e);
                }
            },
            onCellPrepared: CellCustomisation,
            // W0017: width/height as a FUNCTION is deprecated since 21.2 - evaluate at
            // creation instead. Resizes are already explicit everywhere (ResizeDataGrid
            // sets concrete values), so nothing relied on DX re-invoking these.
            height: dataGridProperties.SetGridSize ? GridHeight(dataGridProperties.GridId) : undefined,
            width: dataGridProperties.SetGridSize ? GridWidth(dataGridProperties.GridId) : undefined,
            scrolling: scrollingProps,
            focusedRowEnabled: dataGridProperties.EnableFocusedRow,
            onCellClick: function (e) {
                if (e.cellElement.parents(".dx-datagrid-rowsview").length > 0 && e.cellElement.parents(".dx-freespace-row").length === 0 && e.cellElement.parents(".dx-datagrid-filter-row").length === 0) {
                    DatagridCellClick(e, dataGridProperties.GridId);
                }
                else {
                    e.component.option("focusedRowIndex", -1);
                    e.component.option("focusedColumnIndex", -1);

                    if (e.cellElement.parents(".dx-header-row").length === 0 && !window[dataGridProperties.GridId + "_UseSingleSelectionMode"]) { // Not sorting row and onl multi select grid
                        // Clears selected rows
                        e.component.deselectAll();
                    }
                }
            },
            editing: {
                refreshMode: "repaint",
                allowUpdating: !dataGridProperties.IsReadOnly,
                startEditAction: "click",
                mode: "cell",
                texts: {
                    confirmDeleteMessage: ""
                },
                selectTextOnEditStart: true
            },
            repaintChangesOnly: true,
            paging: {
                enabled: false
            }
        });

        if (!dataGridProperties.ShowColumnLines) {
            $("#" + dataGridProperties.GridId).addClass("Truckcom_RailPlannerGrid");
        }
    }
    else {
        // Missing Properties
    }
}

function EdgeCompatibleTimeEntry(input) {
    input.on("keypress", function (evt) {
        var regex = /^[0-9]+$/;

        if (regex.test(evt.key)) {
            if (evt.target.value.length == 2) {
                evt.target.value = evt.target.value + ":";
            }

            if (evt.target.value.length == 5) {
                evt.preventDefault();
            }
        }
        else {
            return false;
        }
    });
}

function ShowSuccessToast(messageText, timeToDisplayFor) {
    ShowToastNotification(messageText, "success", timeToDisplayFor);
}

function ShowErrorToast(messageText, timeToDisplayFor) {
    ShowWarningPopup(messageText, "Error");
}

function ShowWarningToast(messageText, timeToDisplayFor) {
    ShowWarningPopup(messageText);
}

function ShowToastNotification(messageText, toastType, timeToDisplayFor) {
    // Show a particular toast type with the message text
    if (timeToDisplayFor === undefined) {
        timeToDisplayFor = 12000;
    }

    var ToastConfig = {
        closeOnOutsideClick: true,
        hideOnOutsideClick: true,
        message: messageText,
        visible: true
    };
    DevExpress.ui.notify(ToastConfig, toastType, timeToDisplayFor);
}

function ShowWarningPopup(contentHtml, title, doNotShowCopyButton, autoSize) {
    if ($("#WarningPopup").length == 0) {
        $("body").append($("<div id='WarningPopup' class='Truckcom_Popup_Container'></div>"));
    }

    if (title == undefined) {
        title = "Warning/Information";
    }

    var Height = "35%";
    var Width = "50%";

    if (autoSize) {
        Height = "auto";
        Width = "Auto";
    }

    $("#WarningPopup").dxPopup({
        height: Height,
        width: Width,
        visible: true,
        resizeEnabled: true,
        title: title,
        contentTemplate: function (container) {
            var scrollView = $("<div id='scrollView'></div>");
            var content = $("<div id='WarningPopupContent'></div>");
            var hiddenInput = $("<textarea id='hiddenInput' style='height: 1px; width: 1px; border-width: 0; resize:none;'/>");
            scrollView.append(content);
            content.html(contentHtml);
            hiddenInput.val(contentHtml.replace(/<br>+/g, "\r\n"));
            scrollView.dxScrollView({
                height: '85%',
                width: '100%',
                useNative: true
            });

            var buttonContainerClass = "Truckcom_Popup_ButtonContainer_NoMarginBottom";

            if (autoSize) {
                buttonContainerClass = "Truckcom_Popup_ButtonContainer";
            }

            var buttonContainer = $("<div class='" + buttonContainerClass + "'></div>");
            var closeButton = $("<div id='WarningCloseButton' class='Truckcom_Button'>").dxButton({
                text: "Close",
                type: "default",
                onClick: function (e) {
                    $("#WarningPopup").dxPopup("dispose");
                }
            });
            var copyTextButton = $("<div id='WarningCopyTextButton' class='Truckcom_Button'>").dxButton({
                text: "Copy Text",
                onClick: function (e) {
                    CopyWarningToClipboard("hiddenInput");
                }
            });

            if (!doNotShowCopyButton) {
                buttonContainer.append(copyTextButton);
            }

            buttonContainer.append(closeButton);
            container.append(scrollView);
            container.append(buttonContainer);
            container.append(hiddenInput);

            return container;
        }
    });
}

// The popups open now, as their host elements: the "before" for WhenNewPopupsClosed.
function OpenPopupHosts() {
    return $(".Truckcom_Popup_Container").filter(function () {
        var popup = DevExpress.ui.dxPopup.getInstance(this);
        return !!popup && popup.option("visible");
    }).get();
}

// Runs callback once every popup opened since `before` has closed (a warning, a confirm), straight
// away if there are none. For a step that opens a popup, which would otherwise cover them.
function WhenNewPopupsClosed(before, callback) {
    var open = OpenPopupHosts().filter(function (host) { return $.inArray(host, before) < 0; });
    var left = open.length;
    if (left === 0) {
        callback();
        return;
    }

    $.each(open, function (i, host) {
        var closed = false;
        var finish = function () {
            if (closed) return;
            closed = true;
            left--;
            if (left === 0) setTimeout(callback, 0);
        };
        // The warning's Close button disposes it rather than hiding it, so listen for both.
        var popup = DevExpress.ui.dxPopup.getInstance(host);
        popup.on("hidden", finish);
        popup.on("disposing", finish);
    });
}

function ShowWarning(warning) {
    if (warning !== "") {
        var formattedWarning = htmlDecode(warning.trim(/(?:\r\n|\r|\n)/g).replace(/(?:\r\n|\r|\n)/g, '&lt;br&gt;')); // replace cr/lf with <br>

        var uniqueWarningItems = [];
        $.each(formattedWarning.split("<br>"), function (i, item) {
            if ($.inArray(item.trim(), uniqueWarningItems) == -1) {
                uniqueWarningItems.push(item.trim());
            }
        });

        var warningToShow = uniqueWarningItems.join("<br>");

        if (!warningToShow.includes("&lt;") && !warningToShow.includes("<br>")) {
            ShowWarningToast(htmlDecode(warningToShow));
        } else {
            ShowWarningPopup(warningToShow);
        }
    }
}

function ShowDiagnosticPopup() {
    var diagnosticItems = ["<b>Screen Height:</b> " + screen.height,
    "<b>Screen Width:</b> " + screen.width,
    "<b>Browser Height:</b> " + $(window).height(),
    "<b>Browser Width:</b> " + $(window).width(),
    "<b>Browser Language:</b> " + browserLanguage
    ]

    var diagnosticContent = diagnosticItems.join("<br />");

    $("#DiagnosticPopup").dxPopup({
        contentTemplate: function (contentElement) {
            contentElement.append(diagnosticContent);
        },
        showTitle: true,
        title: "Truckcom Diagnostics",
        height: "auto",
        width: 250,
        visible: true
    });
}

function CopyWarningToClipboard(element) {
    var copyText = document.getElementById(element);
    copyText.select();
    document.execCommand("copy");
}

function brToNewLine(str) {
    return str.replace(/<br ?\/?>/g, "\n");
}

function NewLineToBr(str) {
    return str.replace(RegExp("\n", "g"), "<br>");
}

function keyUpEmailHandler(e, smsService, sendTextForm) {
    if (!sendTextForm) {
        var value = e.element.find("input").val();
        if (smsService !== "") {
            if (value.length == 11 && value.substring(0, 2) === "07") {
                e.component.option("value", value + smsService);
            }
        }
    }
}

function numToSSColumn(num) {
    var s = '', t;

    while (num > 0) {
        t = (num - 1) % 26;
        s = String.fromCharCode(65 + t) + s;
        num = (num - t) / 26 | 0;
    }
    return s || undefined;
}

function ValidateContainer(e) {
    // Uses container validator js 
    if (e !== undefined) {
        var validator = new ContainerValidator();
        return validator.isValid(e.value);
    }
}

// A pallet rate card's "How the price was worked out" lines (StcPalletRateCardCalculator), for the pallet forms' price popups.
function PalletRateCard_WorkingHtml(working, workedOutFrom) {
    var esc = function (s) { return (s == null ? "" : String(s)).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"); };
    var rows = (working || []).map(function (l) {
        return "<tr><td style='padding:1px 12px 1px 0;'>" + esc(l.Label) + "</td><td style='padding:1px 0;white-space:nowrap;'>" + esc(l.Amount) + "</td></tr>";
    });
    var html = "<table style='border-collapse:collapse;'>" + rows.join("") + "</table>";
    if (workedOutFrom) html += "<div style='color:#888;margin-top:2px;'>" + esc(workedOutFrom) + "</div>";
    return html;
}
